// Diagram Viewer — Step 5 Results.
// Stub component for M6.1 diagram generation. Shows Coming Soon placeholders.

import { useState } from 'react';
import type { DiagramType } from '../../types';

interface DiagramTab {
  type: DiagramType;
  label: string;
  milestone: 'M6.1' | 'M6.2';
}

const DIAGRAM_TABS: DiagramTab[] = [
  { type: 'security_zone_map',     label: 'Security Zones',      milestone: 'M6.1' },
  { type: 'compute_cluster',       label: 'Compute Cluster',     milestone: 'M6.1' },
  { type: 'virtualisation_layer',  label: 'Virtualisation Layer',milestone: 'M6.1' },
  { type: 'storage_capacity',      label: 'Storage Capacity',    milestone: 'M6.1' },
  { type: 'dr_architecture',       label: 'DR Architecture',     milestone: 'M6.1' },
  { type: 'rack_population',       label: 'Rack Population',     milestone: 'M6.1' },
  { type: 'logical_dc_topology',   label: 'DC Topology',         milestone: 'M6.2' },
  { type: 'leaf_spine_fabric',     label: 'Fabric Layout',       milestone: 'M6.2' },
];

export function DiagramViewer() {
  const [activeTab, setActiveTab] = useState<DiagramType>('security_zone_map');

  const activeTabDef = DIAGRAM_TABS.find(t => t.type === activeTab)!;

  return (
    <div>
      {/* Tab strip */}
      <div style={{
        display: 'flex',
        gap: 0,
        borderBottom: '2px solid #e2e8f0',
        marginBottom: 24,
        overflowX: 'auto',
      }}>
        {DIAGRAM_TABS.map(tab => {
          const isActive = tab.type === activeTab;
          const isM62 = tab.milestone === 'M6.2';
          return (
            <button
              key={tab.type}
              onClick={() => setActiveTab(tab.type)}
              disabled={isM62}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderBottom: isActive ? '2px solid #1e40af' : '2px solid transparent',
                marginBottom: -2,
                background: 'transparent',
                cursor: isM62 ? 'not-allowed' : 'pointer',
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isM62 ? '#cbd5e1' : isActive ? '#1e40af' : '#475569',
                whiteSpace: 'nowrap',
                opacity: isM62 ? 0.5 : 1,
              }}
            >
              {tab.label}
              {isM62 && (
                <span style={{
                  marginLeft: 6,
                  fontSize: 10,
                  background: '#f1f5f9',
                  color: '#94a3b8',
                  padding: '1px 5px',
                  borderRadius: 4,
                  fontWeight: 500,
                }}>
                  M6.2
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Content area */}
      <div style={{
        borderRadius: 8,
        border: '1px dashed #cbd5e1',
        background: '#f8fafc',
        padding: 48,
        textAlign: 'center',
        minHeight: 260,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
      }}>
        <div style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          background: '#e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 24,
          marginBottom: 4,
        }}>
          🗺
        </div>

        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#1e293b' }}>
          {activeTabDef.label}
        </h3>

        <div style={{
          display: 'inline-block',
          padding: '3px 10px',
          borderRadius: 9999,
          background: '#dbeafe',
          color: '#1e40af',
          fontSize: 12,
          fontWeight: 600,
        }}>
          Coming in {activeTabDef.milestone}
        </div>

        <p style={{ margin: 0, maxWidth: 400, fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>
          {activeTabDef.milestone === 'M6.1'
            ? 'Diagram generation is planned for Milestone 6.1. It will be auto-generated from the sizing result — no extra inputs required.'
            : 'This diagram type requires additional network topology inputs (firewall count, border-leaf count) which will be added in Milestone 6.2.'}
        </p>

        <div style={{
          marginTop: 8,
          padding: '6px 12px',
          borderRadius: 6,
          background: '#fff',
          border: '1px solid #e2e8f0',
          fontSize: 12,
          color: '#94a3b8',
        }}>
          Export formats: Mermaid source · SVG · draw.io XML · draw.io bundle
        </div>
      </div>
    </div>
  );
}
